import { $api } from "../generated/client";

type UseSearchManualSizeBiasCandidateProductsOptions = {
  shopId: string;
  q: string;
  enabled?: boolean;
};

export default function useSearchManualSizeBiasCandidateProducts({
  shopId,
  q,
  enabled = true,
}: UseSearchManualSizeBiasCandidateProductsOptions) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/sizing/manual-bias/products/search",
    {
      params: {
        path: { shopId },
        query: { q },
      },
      enabled: enabled && q.trim().length > 0,
    },
  );
}
